export interface LegitimationListModel {
  id: number;
  date: number;
  type: string;
  event: string;
  isActive: boolean;
  location: string;
  status?: LegitimationStatus;
}

export enum LegitimationStatus {
  New = 'new',
  InProgress = 'inProgress',
  Approved = 'approved',
  Rejected = 'rejected',
  OtherStatus = 'otherStatus'
}

export interface LegitimationStatusResponse {
  status: LegitimationStatus;
}

export interface LegitimationFaxInfoModel {
  faxId: number;
}

export type LegitimationType = 'file' | 'fax' | 'url' | 'noFile';

export interface LegitimationPostModel {
  userLanguage: string;
  legitimationType: LegitimationType;
  comment: string;
  url: string;
  fileId: Array<number>;
  faxId: number;
}
